/* PECTO Reviews — PDP stars + modal (no deps) */
(function () {
  const API = 'https://reviews.pecto.at';
  const elStars = document.getElementById('pecto-stars');
  const shell = document.getElementById('pecto-reviews-root');

  if (!elStars || !shell) return;

  // Move modal to <body> to avoid parent overflow issues
  if (!shell.dataset.moved) {
    document.body.appendChild(shell);
    shell.dataset.moved = '1';
  }

  const modal = shell.querySelector('.pecto-modal');
  const backdrop = shell.querySelector('.pecto-modal__backdrop');

  // PDP product data
  const product = {
    id: elStars.dataset.productId,
    handle: elStars.dataset.productHandle,
    title: elStars.dataset.productTitle,
    image: elStars.dataset.productImage
  };

  // Header fill
  const thumb = shell.querySelector('.pecto-modal__thumb');
  const titleEl = shell.querySelector('.pecto-modal__title');
  if (thumb) thumb.src = product.image || '';
  if (titleEl) titleEl.textContent = product.title || '';

  // Elements in modal
  const modalStars = document.getElementById('pecto-modal-stars');
  const inputTitle = document.getElementById('pecto-title');
  const inputBody = document.getElementById('pecto-body');
  const btnSubmit = document.getElementById('pecto-submit');
  const authBox = document.getElementById('pecto-auth');
  const statusBox = document.getElementById('pecto-status');
  const listBox = document.getElementById('pecto-reviews-list');
  const closeBtn = shell.querySelector('.pecto-modal__close');

  // Logged-in hint (from Shopify).
  // Liquid is NOT rendered in plain .js assets, so read the customer id at
  // runtime from data-* attributes rendered by the Liquid snippets
  // (pecto-reviews-modal / pecto-reviews-stars / pecto-reviews), falling back
  // to Shopify's own storefront globals.
  function readCustomerId() {
    const sources = [
      shell,
      elStars,
      document.querySelector('.pecto-reviews-root[data-customer-id]')
    ];
    for (const el of sources) {
      if (!el || !el.dataset) continue;
      if (el.dataset.loggedIn === 'true') return el.dataset.customerId || 'logged-in';
      const v = (el.dataset.customerId || '').trim();
      if (v && v !== 'null') return v;
    }
    try {
      const sa = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page;
      if (sa && sa.customerId) return String(sa.customerId);
    } catch (_) {}
    try {
      if (window.__st && window.__st.cid) return String(window.__st.cid);
    } catch (_) {}
    return null;
  }
  const isAuthed = !!readCustomerId();
  if (!isAuthed && authBox) authBox.hidden = false;

  let selectedRating = 0;
  let avgRating = 0; // ⭐ NEW: default rating from aggregate

  /* ---------- helpers ---------- */
  const setHover = (wrap, n) => {
    if (!wrap) return;
    wrap.className = wrap.className.replace(/is-hover-\d/g, '').trim();
    if (n) wrap.classList.add('is-hover-' + n);
  };

  const setSelected = (wrap, n) => {
    if (!wrap) return;
    wrap.className = wrap.className.replace(/is-selected-\d/g, '').trim();
    if (n) wrap.classList.add('is-selected-' + n);
  };

  const lockScroll = (on) => {
    document.documentElement.style.overflow = on ? 'hidden' : '';
    document.body.style.overflow = on ? 'hidden' : '';
    document.body.style.touchAction = on ? 'none' : '';
  };

  const openModal = () => {
    shell.hidden = false;
    modal.classList.add('is-open');
    lockScroll(true);
    const firstStar = modalStars?.querySelector('.pecto-star');
    firstStar && firstStar.focus();
  };

  const closeModal = () => {
    modal.classList.remove('is-open');
    lockScroll(false);
    setTimeout(() => { shell.hidden = true; }, 150);
    setHover(modalStars, 0);
  };

  function escapeHtml(s) {
    return (s || '').replace(/[&<>"']/g, m => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[m]));
  }

  /* ---------- ⭐ Fetch aggregate + set default stars ---------- */
  async function loadAggregateAndPaint() {
    try {
      const res = await fetch(`${API}/reviews?handle=${encodeURIComponent(product.handle)}&page=1&page_size=1`, { credentials: 'include' });
      if (!res.ok) return;
      const data = await res.json();

      const agg = data?.aggregate;
      if (!agg) return;

      // avg_rating from server can be string like "5.00"
      const avg = Number(agg.avg_rating || 0);
      const count = Number(agg.count || 0);

      avgRating = count > 0 ? Math.round(avg) : 0;

      // Paint stars under product title (default view)
      if (avgRating > 0) setSelected(elStars, avgRating);
      else setSelected(elStars, 0);

      // Optional: if you have a small text label somewhere, you can set it here
      // e.g. elStars.querySelector('.pecto-stars-meta').textContent = count ? `(${count} · Ø ${avg.toFixed(2)})` : 'Noch keine Bewertungen';
    } catch (_) {}
  }

  /* ---------- PDP stars interactions ---------- */
  elStars.querySelectorAll('.pecto-star').forEach(btn => {
    const v = parseInt(btn.dataset.value, 10);

    btn.addEventListener('mouseenter', () => setHover(elStars, v));

    // IMPORTANT: when leaving, revert to selectedRating if user clicked,
    // otherwise revert to avgRating so it doesn’t go empty
    btn.addEventListener('mouseleave', () => setHover(elStars, 0));

    btn.addEventListener('click', () => {
      selectedRating = v;                 // prefill for modal
      setSelected(elStars, v);
      setSelected(modalStars, v);
      openModal();
    });
  });

  // When leaving the whole star row, restore to picked or average
  elStars.addEventListener('mouseleave', () => {
    setHover(elStars, 0);
    setSelected(elStars, selectedRating || avgRating || 0);
  });

  /* ---------- Modal interactions ---------- */
  closeBtn && closeBtn.addEventListener('click', closeModal);
  backdrop && backdrop.addEventListener('click', closeModal);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  modalStars?.querySelectorAll('.pecto-star').forEach(btn => {
    const v = parseInt(btn.dataset.value, 10);
    btn.addEventListener('mouseenter', () => setHover(modalStars, v));
    btn.addEventListener('mouseleave', () => setHover(modalStars, 0));
    btn.addEventListener('click', () => {
      selectedRating = v;
      setSelected(modalStars, v);
      setSelected(elStars, v);   // mirror on PDP
    });
  });

  /* ---------- Fetch + render existing reviews (FIXED ENDPOINT) ---------- */
  async function loadReviews() {
    if (!listBox) return;
    listBox.innerHTML = '<div class="pecto-review">Laden…</div>';

    try {
      const res = await fetch(
        `${API}/reviews?handle=${encodeURIComponent(product.handle)}&page=1&page_size=20`,
        { credentials: 'include' }
      );
      const data = await res.json().catch(() => null);

      const items = data?.items || [];
      listBox.innerHTML = '';

      if (!items.length) {
        listBox.innerHTML = '<div class="pecto-review">Noch keine Bewertungen.</div>';
        return;
      }

      items.forEach(r => {
        const div = document.createElement('div');
        div.className = 'pecto-review';
        div.innerHTML = `
          <div class="pecto-review__meta">
            ${'★'.repeat(r.rating)}${'☆'.repeat(5 - r.rating)}
            · ${r.created_at ? new Date(r.created_at * 1000).toLocaleDateString('de-AT') : ''}
          </div>
          ${r.title ? `<strong>${escapeHtml(r.title)}</strong><br>` : ''}
          <div>${escapeHtml(r.body || '')}</div>
        `;
        listBox.appendChild(div);
      });

      // Keep stars up-to-date as well
      const agg = data?.aggregate;
      if (agg?.count > 0) {
        const avg = Number(agg.avg_rating || 0);
        avgRating = Math.round(avg);
        if (!selectedRating) setSelected(elStars, avgRating);
      }
    } catch (e) {
      listBox.innerHTML = '<div class="pecto-review">Fehler beim Laden.</div>';
    }
  }

  /* ---------- Submit ---------- */
  btnSubmit?.addEventListener('click', async () => {
    if (!statusBox) return;
    statusBox.hidden = true; statusBox.textContent = '';

    if (!isAuthed) {
      statusBox.hidden = false; statusBox.textContent = 'Bitte anmelden, um zu bewerten.';
      return;
    }
    if (!selectedRating) { statusBox.hidden = false; statusBox.textContent = 'Bitte Sterne wählen.'; return; }
    if ((inputBody?.value || '').trim().length < 20) { statusBox.hidden = false; statusBox.textContent = 'Bitte mindestens 20 Zeichen schreiben.'; return; }

    btnSubmit.disabled = true;

    try {
      const res = await fetch(`${API}/reviews`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          product_id: product.id,
          product_handle: product.handle,
          rating: selectedRating,
          title: inputTitle?.value || '',
          body: inputBody?.value || ''
        })
      });

      const out = await res.json().catch(() => ({}));

      if (out && out.ok) {
        if (inputTitle) inputTitle.value = '';
        if (inputBody) inputBody.value = '';

        statusBox.hidden = false;
        statusBox.textContent = 'Danke! Ihre Bewertung wurde gespeichert.';

        await loadReviews();
        await loadAggregateAndPaint();
      } else {
        throw new Error(out && out.error || 'Unbekannter Fehler');
      }
    } catch (err) {
      statusBox.hidden = false;
      statusBox.textContent = 'Fehler beim Absenden: ' + (err?.message || 'unbekannt');
    } finally {
      btnSubmit.disabled = false;
    }
  });

  // open from a “Bewertungen” link if needed
  window.PECTO_OPEN_REVIEWS = function () { openModal(); };

  // Initial load when first opened
  const observer = new MutationObserver(() => {
    if (modal.classList.contains('is-open')) {
      observer.disconnect();
      loadReviews();
    }
  });
  observer.observe(modal, { attributes: true, attributeFilter: ['class'] });

  // ⭐ Run on page load to paint stars immediately
  loadAggregateAndPaint();
})();